module.exports = __webpack_public_path__ + "img/BkgLicencias.59b65727.jpg";